import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import { BrowserRouter } from "react-router-dom";
import { instalarAvisoDeSesionVencida } from "./utils/sesionVencida";

axios.defaults.baseURL = process.env.REACT_APP_API || "http://localhost:3001";
// Necesario para que el browser envíe cookies httpOnly en requests cross-origin (dev: :3000 → :3001)
axios.defaults.withCredentials = true;
instalarAvisoDeSesionVencida();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
);

reportWebVitals();
